let mapper_options = {
  endpoint: 'retailer_accounts',
  recordClass: require('./record'),
  relations: {
    hasMany: {
      user: {
        localKeys: 'user_ids',
        localField: 'users'
      },
      retailer: {
        foreignKey: 'retailer_account_id',
        localField: 'retailers'
      },
      brand_request: {
        foreignKey: 'retailer_account_id',
        localField: 'retailer_accounts'
      }
    }
  }
}

module.exports = (store) => {
  store.defineMapper('retailer_account', mapper_options)
}
